import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "fill-rule": "evenodd",
  stroke: "#444545",
  "stroke-linecap": "round",
  "stroke-width": "3",
  viewBox: "0 0 240 240"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M.75.75h237.5v237.5H.75z" }, null, -1),
    _createElementVNode("g", { "stroke-linecap": "butt" }, [
      _createElementVNode("path", { d: "M30.42 238.25V.75m29.717 96.9V.75m29.67 79.309V.75m29.717 237.501v-74.223m0-89.055V.75m29.67 79.546V.75m29.717 96.9V.75m29.67 237.5V.75M30.42 164.028c0-49.213 39.89-89.056 89.056-89.056s89.058 39.89 89.058 89.056M60.137 238.25v-74.223c0-32.758 26.628-59.386 59.385-59.386s59.39 26.628 59.39 59.386v74.223m-89.153 0v-74.223c0-16.356 13.312-29.668 29.669-29.668s29.668 13.312 29.668 29.668v74.223" })
    ], -1)
  ])))
}
export default { render: render }